import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import * as S from './SectionDepoimentos.styles'

export interface Testimonial {
  text: string
  author: string
  role: string
}

interface SectionDepoimentosProps {
  title?: string
  testimonials?: Testimonial[]
  showAll?: boolean
  fontSize?: string
}

const SectionDepoimentos = ({
  title: titleProp,
  testimonials: testimonialsProp,
  showAll = false,
  fontSize
}: SectionDepoimentosProps = {}) => {
  const { t } = useTranslation()
  const [current, setCurrent] = useState(0)
  const visible = 3

  const translatedTitle = t('landingV2.sectionDepoimentos.title')
  const resolvedTitle = titleProp ?? translatedTitle

  const translatedTestimonials = t(
    'landingV2.sectionDepoimentos.testimonials',
    {
      returnObjects: true
    }
  ) as Testimonial[]

  const resolvedTestimonials: Testimonial[] =
    testimonialsProp ??
    (Array.isArray(translatedTestimonials) ? translatedTestimonials : [])

  const total = resolvedTestimonials.length
  const visibleCount = showAll ? total : visible
  const maxIndex = Math.max(0, total - visibleCount)

  const handleBulletClick = (idx: number) => {
    setCurrent(idx)
  }

  return (
    <S.Section>
      <S.Title>{resolvedTitle}</S.Title>
      <S.CarouselWrapper>
        <S.Carousel>
          {resolvedTestimonials
            .slice(current, current + visibleCount)
            .map((item, idx) => (
              <S.Card key={idx}>
                <S.Text1 style={fontSize ? { fontSize } : undefined}>
                  {item.text}
                </S.Text1>
                <S.Text2 style={fontSize ? { fontSize } : undefined}>
                  <strong>{item.author}</strong>
                  <br />
                  {testimonialsProp ? (
                    <span dangerouslySetInnerHTML={{ __html: item.role }} />
                  ) : (
                    <Trans
                      i18nKey={`landingV2.sectionDepoimentos.testimonials.${idx + current}.role`}
                      components={{ br: <br /> }}
                    >
                      {item.role}
                    </Trans>
                  )}
                </S.Text2>
              </S.Card>
            ))}
        </S.Carousel>
        {total > visibleCount && (
          <S.Bullets>
            {Array.from({ length: maxIndex + 1 }).map((_, idx) => (
              <S.Bullet
                key={idx}
                active={idx === current}
                onClick={() => handleBulletClick(idx)}
                aria-label={`Ir para depoimento ${idx + 1}`}
              />
            ))}
          </S.Bullets>
        )}
      </S.CarouselWrapper>
    </S.Section>
  )
}

export default SectionDepoimentos
